@if (!!entity) {
  <now-favorit-toggle
    [attr.target-slug]="targetSlug"
    [attr.x-api-key]="xApiKey"
    [attr.basisdienst]="entity.basisdienst"
    [attr.favorit-title]="entity.favoritTitle"
    [attr.target-id]="entity.targetId"
    [attr.details-begin]="weiterbildung.detailsBegin"
    [attr.details-end]="weiterbildung.detailsEnd"
    [attr.details-location]="weiterbildung.detailsLocation"
    [attr.details-anbieter]="weiterbildungsAngebot.detailsAnbieter"
    [attr.details-search-filter]="weiterbildungsSuche.detailsSearchFilter"
    [attr.details-search-keywords]="weiterbildungsSuche.detailsSearchKeywords"
    [attr.details-search-location]="weiterbildungsSuche.detailsSearchLocation"
    [attr.details-search-postcode]="weiterbildungsSuche.detailsSearchPostcode"
    icon-only="false"
  ></now-favorit-toggle>
}
